import SvgToScale from './SvgToScale';
import { hasVideo } from './cropsUtil';
/**
 *
 * @param {SVGElement} svg
 */
function convert(svgDom, cropInfo, isAi) {
  const { scale, sizeId, width, height } = cropInfo;
  const multipleScales = Array.isArray(scale);
  let svg = multipleScales && !isAi ? null : svgDom.cloneNode(true);

  const isVideo = hasVideo(sizeId);
  if (isAi) {
    // translate fonts into illustarator language
    if (isVideo) convertVideoText(svg);
  } else {
    if (multipleScales) {
      return scale.map((s) => {
        svg = svgDom.cloneNode(true);
        SvgToScale.apply(svg, s, width, height);
        return svg.outerHTML;
      });
    }
    if (scale !== 1) {
      SvgToScale.apply(svg, scale, width, height);
    }
  }
  if (isAi) {
    return removeFillAttrs(svg.outerHTML);
  }
  return svg.outerHTML;
}

function convertVideoText(svg) {
  const text = svg.querySelectorAll('text');
  text.forEach((textEl) => {
    const weight = textEl.style.fontWeight;
    textEl.style.fontFamily = getFontRetinaNarrow(weight);
    if (weight) textEl.style.fontWeight = '';
  });
  const annotations = svg.querySelectorAll('.highcharts-annotation-label tspan');
  if (annotations.length) {
    annotations.forEach((tspan, i) => {
      if (tspan.style.fontWeight) {
        tspan.style.fontFamily = getFontRetinaNarrow(tspan.style.fontWeight);
        tspan.style.fontWeight = '';
      }
    });
  }
}

function removeFillAttrs(svgStr) {
  return svgStr
    .replace('fill="transparent" class="highcharts-background"', 'class="highcharts-background"')
    .replace('fill="none" class="highcharts-plot-background"', 'class="highcharts-plot-background"')
    .replace('fill="none" class="highcharts-plot-border"', 'class="highcharts-plot-border"');
}

function getFontRetinaNarrow(weight /* style */) {
  let weightStr = '';
  switch (weight) {
    case '300':
      weightStr = 'Light';
      break;
    case '400':
      weightStr = 'Book';
      break;
    case '500':
      weightStr = 'Med';
      break;
    case '700':
    case 'bold':
      weightStr = 'Bold';
      break;
    default:
      weightStr = 'Book';
      break;
  }
  // const styleStr = style === 'italic' ? 'Italic' : '';
  return `RetinaWide${weightStr}`;
}

export default { convert };
